// const config = {
//   api: "http://localhost:8080/api",
// };

const config = {
  api: "https://xapi.lisaconnect.fr/api",
};

export default config;
